import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 100;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const serviceAreas = [
    "Orlando, FL",
    "Kissimmee, FL",
    "Davenport, FL",
    "Winter Garden, FL",
    "Windermere, FL",
    "Lake Nona, FL",
    "Clermont, FL",
    "Sanford, FL"
  ];

  const services = [
    "Residential Roofing",
    "Commercial Roofing",
    "Roof Repair",
    "Roof Replacement",
    "Roof Installation",
    "Insurance Claims",
    "Emergency Tarp Service",
    "Roof Inspections"
  ];

  return (
    <footer className="bg-[#0f172a] text-white">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company */}
          <div className="space-y-4">
            <div className="mb-4">
              <img 
                src="/assets/logo-white.png" 
                alt="Elite Roofing and Construction LLC" 
                className="h-20 w-auto"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Elite Roofing and Construction LLC specializes in professional roofing and exterior construction services throughout Central Florida.
            </p>
            <div className="space-y-2">
              <p className="text-sm font-semibold text-white">Licensed & Insured</p>
              <p className="text-xs text-slate-400">Serving Central Florida</p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg">Our Services</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              {services.slice(0, 6).map((service, index) => (
                <li key={index}>
                  <button 
                    onClick={() => scrollToSection('services')} 
                    className="hover:text-white transition-colors"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg">Service Areas</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              {serviceAreas.map((area, index) => (
                <li key={index}>{area}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg">Contact Us</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <a href="tel:+14077850642" className="hover:text-white transition-colors flex items-center gap-2">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  (407) 785-0642
                </a>
              </li>
              <li>
                <a href="mailto:jeremy@elitercfl.com" className="hover:text-white transition-colors flex items-center gap-2">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  jeremy@elitercfl.com
                </a>
              </li>
              <li>
                <a href="https://elitercfl.com" className="hover:text-white transition-colors flex items-center gap-2">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                  elitercfl.com
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <button 
                onClick={scrollToTop}
                className="text-sm font-semibold text-[hsl(var(--accent))] hover:text-white transition-colors flex items-center gap-2"
              >
                Schedule Free Inspection 
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>
              © {currentYear} Elite Roofing and Construction LLC. All rights reserved.
            </p>
            <p className="text-xs">
              Licensed & Insured | Central Florida Roofing Contractor
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}